<div class="container">
  <form [formGroup]="stepThreeForm">
    <div class="form-group" style="margin-bottom: 0 !important;">
      <div class="row mt-2">
        <div class="col-12 col-lg-6 mb-1">
          <label for="installer_companyname" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.COMPANYNAME" |
            translate}}<sup class="small-asterisk">*</sup></label>
          <input type="text" name="installer_companyname" id="installer_companyname"
            formControlName="installer_companyname" class="form-control"
            placeholder="{{'SYSTEM.STEPTHREE.COMPANYNAMEPLACEHOLDER' | translate}}"
            [class.is-invalid]="stepThreeForm.get('installer_companyname')?.invalid && (stepThreeForm.get('installer_companyname')?.dirty || submitted)">
          <div class="text-danger mt-1" *ngIf="stepThreeForm.get('installer_companyname')?.invalid && (stepThreeForm.get('installer_companyname')?.dirty || submitted)" style="font-size: small;">
            {{"SYSTEM.STEPTHREE.NAMEERROR" | translate}}</div>
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <label for="installer_address" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.COMPANYADDRESS" |
            translate}}<sup class="small-asterisk">*</sup></label>
          <input type="text" name="address" id="installer_address" formControlName="installer_address"
            class="form-control" placeholder="{{'SYSTEM.STEPTHREE.ADDRESSPLACEHOLDER' | translate}}"
            [class.is-invalid]="stepThreeForm.get('installer_address')?.invalid && (stepThreeForm.get('installer_address')?.dirty || submitted)">
          <div class="text-danger mt-1" *ngIf="stepThreeForm.get('installer_address')?.invalid && (stepThreeForm.get('installer_address')?.dirty || submitted)" style="font-size: small;">
            {{"SYSTEM.STEPTHREE.ADDRESSERROR" | translate}}</div>
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <label for="idcountry" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.COMPANYCOUNTRY" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <select class="form-select" aria-label="select example" formControlName="idcountry"
          [class.is-invalid]="stepThreeForm.get('idcountry')?.invalid && (stepThreeForm.get('idcountry')?.dirty || submitted)">
            <option [ngValue]="null" disabled>{{"SYSTEM.STEPTHREE.COUNTRYSELECT" | translate}}</option>
            <option *ngFor="let country of countriesData" [ngValue]="country.id">
              <!-- <img src="{{country.flag_png}}" width="20px" height="15px">  -->
              {{ country.common_name }}
            </option>
          </select>
          <div class="text-danger mt-1" *ngIf="stepThreeForm.get('idcountry')?.invalid && (stepThreeForm.get('idcountry')?.dirty || submitted)" style="font-size: small;">
            {{"SYSTEM.STEPTHREE.COUNTRYERROR" | translate}}</div>
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <label for="vendor_contact" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.VENDORCONTACT" |
            translate}}</label>
          <input type="text" name="vendor_contact" id="vendor_contact" formControlName="vendor_contact"
            class="form-control" placeholder="{{'SYSTEM.STEPTHREE.VENDORPLACEHOLDER' | translate}}">
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <label for="installer_email" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.EMAIL" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <input type="installer_email" name="installer_email" id="installer_email" formControlName="installer_email"
            class="form-control" placeholder="{{'SYSTEM.STEPTHREE.EMAIL' | translate}}"
            [class.is-invalid]="stepThreeForm.get('installer_email')?.invalid && (stepThreeForm.get('installer_email')?.dirty || submitted)">
          <div class="text-danger mt-1" *ngIf="stepThreeForm.get('installer_email')?.invalid && (stepThreeForm.get('installer_email')?.dirty || submitted)" style="font-size: small;">
            {{"SYSTEM.STEPTHREE.EMAILERROR" | translate}}</div>
        </div>

        <!-- DATA DI ACQUISTO -->
        <div class="col-12 col-lg-6 mb-3">
          <label for="installer_dateofpurchase" style="font-weight: bold;">{{"SYSTEM.STEPTHREE.DATEOFPURCHASE" |
            translate}}<sup class="small-asterisk">*</sup></label>
          <input type="date" name="installer_dateofpurchase" id="installer_dateofpurchase"
            formControlName="installer_dateofpurchase" class="form-control"
            placeholder="{{'SYSTEM.STEPTHREE.DATEPLACEHOLDER' | translate}}"
            [class.is-invalid]="stepThreeForm.get('installer_dateofpurchase')?.invalid && (stepThreeForm.get('installer_dateofpurchase')?.dirty || submitted)">
          <div class="text-danger mt-1" *ngIf="stepThreeForm.get('installer_dateofpurchase')?.invalid && (stepThreeForm.get('installer_dateofpurchase')?.dirty || submitted)" style="font-size: small;">
            {{"SYSTEM.STEPTHREE.DATEERROR" | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-2">
      <ng-container *ngFor="let image3 of imagesStep3">
        <div class="col-xs-12 col-sm-6 col-md-2 mb-4 text-center" style="width: 100px; height: 100px;">
          <!-- L'URL sicuro è già gestito nel componente -->
          <ng-container *ngIf="image3.ext != 'pdf'; else pdfBlock">
            <ng-container *ngIf="isImageFile(image3.ext); else generic">
              <img [src]="urlServerLaraMedia + image3.src" [alt]="image3.title" class="img-fluid thumbnailImg"
                (click)="viewImage(image3)">
            </ng-container>
            <!-- If it's neither PDF nor a valid image extension, display a generic icon -->
            <ng-template #generic>
              <a [href]="urlServerLaraMedia+image3.src" target="_blank">
                <img src="assets/img/fileThumbnail.png" [alt]="image3.title" class="img-fluid thumbnailImg">
              </a>
            </ng-template>
          </ng-container>
          <ng-template #pdfBlock>
            <img src="assets/img/pdfThumbnail.png" [alt]="image3.title" class="img-fluid thumbnailImg"
              (click)="viewImage(image3)">
          </ng-template>


          <!-- <img *ngIf="image3.ext != 'pdf'; else pdfBlock" [src]="urlServerLaraMedia+image3.src" [alt]="image3.title" class="img-fluid thumbnailImg" (click)="viewImage(image3)">
          <ng-template #pdfBlock>
            <img src="assets/img/pdfThumbnail.png" [alt]="image3.title" class="img-fluid thumbnailImg" (click)="viewImage(image3)">
          </ng-template> -->
          <i class="bi bi-trash trash" (click)="deleteImg(image3.id)"></i>
        </div>
      </ng-container>
    </div>
    <div class="row justify-content-center mb-3 mt-2">
      <div class="col-md-4 text-center d-flex flex-column" style="max-width: 250px;">
        <div class="col-12 text-center" style="font-size: small;">
          {{"SYSTEM.STEPTHREE.IMPORTINVOICE" | translate}}
        </div>
        <label *ngIf="!imageSpaceLeftStep3" class="text-danger">
          {{"SYSTEM.STEPTHREE.IMAGELIMIT" | translate}}
        </label><br>
        <label *ngIf="imagesStep3.length < maxImagesStep3" for="fileUpload3" class="btn btn-outline-dark mt-1">
          <i class="bi bi-upload" style="margin-right: 4px;"></i>
          {{"SYSTEM.STEPTHREE.IMPORT" | translate}}
          <input type="file" id="fileUpload3" style="display: none;" (change)="onFileSelected($event)"
            multiple>
        </label>
      </div>
    </div>

    <div *ngIf="!isReadonly; else updateBlock" class="col-12 text-center px-0">
      <button class="btn btn-outline-dark me-0 me-md-2" (click)="previous()">
        {{"SYSTEM.STEPBUTTONS.PREV" | translate}}
      </button>
      <button class="btn btn-outline-dark ms-1 me-1 ms-md-2 me-md-2" id="next" (click)="saveStep('save')">
        {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
      </button>
      <button class="btn btn-outline-dark me-0 ms-md-2" [disabled]="stepThreeForm.invalid || isError"
        (click)="saveStep('next')">
        {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
      </button>
    </div>
    <ng-template #updateBlock>
      <div class="col-12 text-center">
        <button class="btn btn-outline-dark" (click)="approvalRequested()">
          {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
        </button>
      </div>
    </ng-template>
  </form>
</div>
